import React from 'react';
import { Users, Package, MapPin, Award } from 'lucide-react';

const stats = [
  { icon: Users, value: '500+', label: 'Clientes Satisfeitos' },
  { icon: Package, value: '2000+', label: 'Produtos Vendidos' },
  { icon: MapPin, value: '50+', label: 'Cidades Atendidas' },
  { icon: Award, value: '35+', label: 'Anos de Tradição' },
];

const StatsSection = () => {
  return (
    <section className="py-16 bg-green-50">
      <div className="container-custom">
        <div className="text-center mb-10">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground">Números que Falam</h2>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div 
              key={index} 
              className="stats-card flex flex-col items-center p-6 bg-white rounded-2xl shadow-sm border border-green-100 transition-all duration-300 hover:-translate-y-1 hover:shadow-md animate-in fade-in slide-in-from-bottom-4 fill-mode-both"
              style={{ animationDelay: `${index * 150}ms` }}
            >
              <div className="stats-icon w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mb-4">
                <stat.icon className="w-8 h-8 text-green-600" />
              </div>
              <div className="stats-number text-4xl font-extrabold text-foreground mb-2" style={{ fontVariantNumeric: 'tabular-nums' }}>
                {stat.value}
              </div>
              <div className="stats-label text-sm font-medium text-muted-foreground uppercase tracking-wider text-center">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;